<ng-container *ngIf="isLoading">
    <div class="jobpost">
        <div class="jobheading seen-notification location-detail" *ngFor="let i of [1,2,3,4,5]">
            <figure>
                <ngx-skeleton-loader [theme]="{ width: '30px', height: '30px', 'border-radius': '0px'}" appearance="circle"></ngx-skeleton-loader>
            </figure>
            <p>
                <ngx-skeleton-loader [theme]="{ width: '80%'}"></ngx-skeleton-loader>
            </p>
            <div class="daysago">
                <ngx-skeleton-loader [theme]="{ width: '10%'}"></ngx-skeleton-loader>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!isLoading && !result">
    <div class="jobpost no-record-found">
        <div class="text-center">
            <h2>{{'SHARED.ELEMENT.NOTIFICATION.NO_NOTIFICATION' | translate}}</h2>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!isLoading && result">
    <div class="jobpost">
        <div [ngClass]="notification.is_seen?'jobheading seen-notification location-detail':'jobheading location-detail'" *ngFor="let notification of notificationData">
            <figure>
                <img src="{{env.SITE_IMAGE_URL}}notification-profile.svg" alt="img" class="blue-icon">
            </figure>

            <p>
                <a href="javascript:void(0);" *ngIf="notification.notification_type == 15">{{notification.message}}</a>

                <a routerLink="/jobseeker/purchased-service-list" *ngIf="notification.notification_type == 14">{{notification.message}}</a>

                <a routerLink="/employer/subscription_plans" *ngIf="notification.notification_type == 5">{{notification.message}}</a>

                <a routerLink="/employer/applications/{{notification.extra_parameters.job_slug}}/{{notification.extra_parameters.candadite_slug}}" *ngIf="notification.notification_type == 7">{{notification.message}}</a>

                <a routerLink="/jobs/description/{{notification.extra_parameters.job_slug}}" *ngIf="notification.notification_type == 10">{{notification.message}}</a>

                <a routerLink="/jobseeker/applied_job" *ngIf="notification.notification_type == 8">{{notification.message}}</a>

                <a routerLink="/jobseeker/applied_job" *ngIf="notification.notification_type == 16">{{notification.message}}</a>

                <a routerLink="/jobseeker/applied_job" *ngIf="notification.notification_type == 17">{{notification.message}}</a>

                <a routerLink="/jobseeker/applied_job" *ngIf="notification.notification_type == 18">{{notification.message}}</a>

                <a routerLink="/jobseeker/applied_job" *ngIf="notification.notification_type == 19">{{notification.message}}</a>

                <a routerLink="/jobseeker/schedule_interview" *ngIf="notification.notification_type == 20">{{notification.message}}</a>

                <a routerLink="/jobseeker/applied_job" *ngIf="notification.notification_type == 21">{{notification.message}}</a>

                <a routerLink="/jobseeker/schedule_interview" *ngIf="notification.notification_type == 22">{{notification.message}}</a>

                <a routerLink="/employer/applications/{{notification.extra_parameters.job_slug}}/{{notification.extra_parameters.candadite_slug}}" *ngIf="notification.notification_type == 23">{{notification.message}}</a>

                <a routerLink="/jobseeker/chat/{{notification.extra_parameters.chat_id}}" *ngIf="notification.notification_type == 24">{{notification.message}}</a>

                <a routerLink="/jobseeker/chat/{{notification.extra_parameters.chat_id}}" *ngIf="notification.notification_type == 25">{{notification.message}}</a>

                <a routerLink="/employer/chat/{{notification.extra_parameters.chat_id}}" *ngIf="notification.notification_type == 26">{{notification.message}}</a>

                <a routerLink="/employer/chat/{{notification.extra_parameters.chat_id}}" *ngIf="notification.notification_type == 27">{{notification.message}}</a>

                <a routerLink="/jobseeker/schedule_interview" *ngIf="notification.notification_type == 28">{{notification.message}}</a>

                <a routerLink="/employer/chat/{{notification.extra_parameters.chat_id}}" *ngIf="notification.notification_type == 29">{{notification.message}}</a>

                <a routerLink="/employer/chat/{{notification.extra_parameters.chat_id}}" *ngIf="notification.notification_type == 30">{{notification.message}}</a>

                <a routerLink="/jobseeker/chat/{{notification.extra_parameters.chat_id}}" *ngIf="notification.notification_type == 31">{{notification.message}}</a>

                <a routerLink="/jobs/description/{{notification.extra_parameters.job_slug}}" *ngIf="notification.notification_type == 9">{{notification.message}}</a>

                <a routerLink="/employer/subscription_plans" *ngIf="notification.notification_type == 11">{{notification.message}}</a>

                <a href="javascript:void(0);" *ngIf="userService.getCurrentUser().resume_writer">{{notification.message}}</a>
            </p>
            <div class="daysago">Read on {{notification.created | date : 'MMM d yyyy'}}</div>
        </div>
    </div>
    <my-pagination (goPage)="goToPage($event)" (goNext)="onNext()" (goPrev)="onPrev()" [pagesToShow]="env.TOTAL_PAGE_TO_SHOW" [page]="current_page" [perPage]="limit" [count]="total_record">
    </my-pagination>
</ng-container>